import React from "react";
import "./Footer.css";
import logo from "../../assets/logo3.png";

const Footer = () => {
  return (
    <footer className="zikr-footer">
      <div className="footer-container">
        {/* Logo + Description */}
        <div className="footer-logo">
          <img src={logo} alt="ZikRme Logo" className="logo-img" />
          <p className="footer-tagline">
            Explore unique, personalized travel <br/>experiences with
            ZikRme Tours worldwide.
          </p>
          <div className="subscribe-box">
            <input type="email" placeholder="Email Address" />
            <button>Subscribe</button>
          </div>
        </div>

        {/* Contact Section + Subscribe */}
        <div className="footer-column">
          <div className="quick-div" style={{ marginTop: "12px" }}>
            <h4>Quick Contact</h4>

            <p>
              <i className="ri-phone-line"></i> +91 7310624101
            </p>
            <p>
              <i className="ri-map-pin-line"></i> Uttar Pradesh, India
            </p>
            <p>
              <i className="ri-mail-line"></i> ZikRmeofficial@gmail.com
            </p>
          </div>
          <div className="follow-div">
            <p className="follow-heading">Follow Us</p>
            <div className="footer-icons" style={{ display: "flex" }}>
              <p>
                <i class="ri-facebook-fill"></i>
              </p>
              <p>
                <i class="ri-whatsapp-line"></i>
              </p>
              <p>
                <i class="ri-instagram-line"></i>
              </p>
              <p>
                <i class="ri-youtube-line"></i>
              </p>
            </div>
            <div style={{ marginLeft: "20px" }}>
              <p><a
                className="footer-link"
                href="https://zikrme.com/privacy-policy/"
              >
                Privacy Policy
              </a></p>
            
              
             <p> <a
                className="footer-link"
                href="https://zikrme.com/terms-conditions/"
              >
                Term & Condition
              </a></p>
            
              <p>
              ZikRme Id Verification
              </p>
              </div>
          </div>
        </div>
      </div>
      <br></br>
      <p className="copy-right">© 2025 ZikRme. All Rights Reserved</p>
    </footer>
  );
};

export default Footer;
